export const mockCasinos = [
  {
    id: 1,
    name: "CircusBet",
    logo: "https://img.logo.dev/circusbet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.5,
    mainBonus: "Bonus de bienvenue jusqu'à 100€",
    secondaryBonus: "100% sur le premier dépôt",
    extraBonus: "50 Paris Gratuits",
    claimedCodes: 245,
    url: "https://circusbet.fr",
    score: 8.5,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal"],
    authorized: "ARJEL",
    termsDetails: "Offre réservée aux nouveaux clients. Conditions d'âge et territoriales applicables.",
    gallery: []
  },
  {
    id: 2,
    name: "Vibrez",
    logo: "https://img.logo.dev/vibrez.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.2,
    mainBonus: "Paris gratuit de 50€",
    secondaryBonus: "Cashback hebdomadaire 10%",
    extraBonus: null,
    claimedCodes: 189,
    url: "https://vibrez.fr",
    score: 8.2,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "Skrill"],
    authorized: "ARJEL",
    termsDetails: "Promotion réservée aux nouveaux clients majeurs résidant en France.",
    gallery: []
  },
  {
    id: 3,
    name: "DAZNbet",
    logo: "https://img.logo.dev/daznbet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.8,
    mainBonus: "100€ offerts à l'inscription",
    secondaryBonus: "Streaming DAZN inclus",
    extraBonus: "Paris combinés boostés",
    claimedCodes: 567,
    url: "https://daznbet.fr",
    score: 8.8,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Apple Pay"],
    authorized: "ARJEL",
    termsDetails: "Offre valable pour tout nouveau compte ouvert. Conditions générales applicables.",
    gallery: []
  },
  {
    id: 4,
    name: "Bwin",
    logo: "https://img.logo.dev/bwin.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.2,
    mainBonus: "Bonus de bienvenue 120€",
    secondaryBonus: "Paris sans risque",
    extraBonus: "Cotes boostées quotidiennes",
    claimedCodes: 892,
    url: "https://bwin.fr",
    score: 9.2,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Neteller"],
    authorized: "ARJEL",
    termsDetails: "Offre de bienvenue réservée aux nouveaux clients. 18+ uniquement.",
    gallery: []
  },
  {
    id: 5,
    name: "Betclic",
    logo: "https://img.logo.dev/betclic.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.0,
    mainBonus: "100€ de Paris Gratuits",
    secondaryBonus: "Remboursement premier pari",
    extraBonus: "Programme de fidélité VIP",
    claimedCodes: 734,
    url: "https://betclic.fr",
    score: 9.0,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Paysafecard"],
    authorized: "ARJEL",
    termsDetails: "Bonus de bienvenue sous conditions. Voir conditions sur le site.",
    gallery: []
  },
  {
    id: 6,
    name: "Betsson",
    logo: "https://img.logo.dev/betsson.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.6,
    mainBonus: "Paris gratuit de 75€",
    secondaryBonus: "100% premier dépôt",
    extraBonus: "Tours gratuits casino",
    claimedCodes: 298,
    url: "https://betsson.fr",
    score: 8.6,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "Skrill", "Neteller"],
    authorized: "ARJEL",
    termsDetails: "Offre soumise à conditions. Joueurs français uniquement.",
    gallery: []
  },
  {
    id: 7,
    name: "ParionsWeb (FDJ)",
    logo: "https://img.logo.dev/parionsweb.fdj.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.9,
    mainBonus: "15€ offerts sans dépôt",
    secondaryBonus: "100€ de bonus sur premier dépôt",
    extraBonus: "Grilles Loto offertes",
    claimedCodes: 1205,
    url: "https://parionsweb.fdj.fr",
    score: 8.9,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Virement"],
    authorized: "ARJEL",
    termsDetails: "Offre FDJ réservée aux nouveaux parieurs. Conditions sur fdj.fr",
    gallery: []
  },
  {
    id: 8,
    name: "FeelingBet",
    logo: "https://img.logo.dev/feelingbet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.1,
    mainBonus: "Bonus de bienvenue 50€",
    secondaryBonus: "Paris combinés assurés",
    extraBonus: null,
    claimedCodes: 156,
    url: "https://feelingbet.fr",
    score: 8.1,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "PayPal"],
    authorized: "ARJEL",
    termsDetails: "Bonus sous réserve de validation du compte joueur.",
    gallery: []
  },
  {
    id: 9,
    name: "Olybet",
    logo: "https://img.logo.dev/olybet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.3,
    mainBonus: "Paris gratuit 80€",
    secondaryBonus: "Cashback sport 5%",
    extraBonus: "Bonus casino inclus",
    claimedCodes: 267,
    url: "https://olybet.fr",
    score: 8.3,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "Skrill"],
    authorized: "ARJEL",
    termsDetails: "Offre de bienvenue multi-produits. Voir conditions générales.",
    gallery: []
  },
  {
    id: 10,
    name: "Genybet",
    logo: "https://img.logo.dev/genybet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.4,
    mainBonus: "100€ de Paris Gratuits",
    secondaryBonus: "Spécialiste courses hippiques",
    extraBonus: "Pronostics experts gratuits",
    claimedCodes: 445,
    url: "https://genybet.fr",
    score: 8.4,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Chèque"],
    authorized: "ARJEL",
    termsDetails: "Expert du pari hippique depuis 1981. Conditions spéciales courses.",
    gallery: []
  },
  {
    id: 11,
    name: "YESorNO",
    logo: "https://img.logo.dev/yesorno-jeu.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 7.9,
    mainBonus: "Pari gratuit 25€",
    secondaryBonus: "Interface innovante",
    extraBonus: "Paris flash express",
    claimedCodes: 123,
    url: "https://yesorno-jeu.fr",
    score: 7.9,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "PayPal"],
    authorized: "ARJEL",
    termsDetails: "Concept de pari révolutionnaire. Simplicité et rapidité.",
    gallery: []
  },
  {
    id: 12,
    name: "NetBet",
    logo: "https://img.logo.dev/netbet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.7,
    mainBonus: "100€ de Bonus + 25 Tours",
    secondaryBonus: "NetBet Sport + Casino",
    extraBonus: "Programme VIP exclusif",
    claimedCodes: 678,
    url: "https://netbet.fr",
    score: 8.7,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Neteller", "Skrill"],
    authorized: "ARJEL",
    termsDetails: "Bonus combiné sport et casino. Double avantage pour les nouveaux clients.",
    gallery: []
  },
  {
    id: 13,
    name: "PMU",
    logo: "https://img.logo.dev/pmu.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.1,
    mainBonus: "150€ de Paris Gratuits",
    secondaryBonus: "Leader du pari hippique",
    extraBonus: "Cagnotte millionnaire",
    claimedCodes: 1567,
    url: "https://pmu.fr",
    score: 9.1,
    minDeposit: "5€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Prélèvement", "Espèces"],
    authorized: "ARJEL",
    termsDetails: "Référence française du pari. Hippique, sport et poker réunis.",
    gallery: []
  },
  {
    id: 14,
    name: "PokerStars Sports",
    logo: "https://img.logo.dev/pokerstars.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.3,
    mainBonus: "Bonus de bienvenue 100€",
    secondaryBonus: "PokerStars + Paris Sportifs",
    extraBonus: "Tournois poker gratuits",
    claimedCodes: 923,
    url: "https://pokerstars.fr",
    score: 9.3,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Neteller", "Skrill"],
    authorized: "ARJEL",
    termsDetails: "Numéro 1 mondial du poker + paris sportifs. Double expertise.",
    gallery: []
  },
  {
    id: 15,
    name: "Unibet",
    logo: "https://img.logo.dev/unibet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.0,
    mainBonus: "100€ de Paris Gratuits",
    secondaryBonus: "Live streaming inclus",
    extraBonus: "Cotes améliorées quotidiennes",
    claimedCodes: 812,
    url: "https://unibet.fr",
    score: 9.0,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Neteller", "Trustly"],
    authorized: "ARJEL",
    termsDetails: "Opérateur européen de référence. Sport, casino et poker.",
    gallery: []
  },
  {
    id: 16,
    name: "VBET",
    logo: "https://img.logo.dev/vbet.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 8.2,
    mainBonus: "Paris gratuit 60€",
    secondaryBonus: "Cashback hebdomadaire",
    extraBonus: "Application mobile premium",
    claimedCodes: 334,
    url: "https://vbet.fr",
    score: 8.2,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "Skrill", "Neteller"],
    authorized: "ARJEL",
    termsDetails: "Technologie de pointe pour l'expérience de pari ultime.",
    gallery: []
  },
  {
    id: 17,
    name: "Winamax",
    logo: "https://img.logo.dev/winamax.fr?token=pk_eMUhsJpgT66kZAiJ3t0bnw",
    rating: 9.4,
    mainBonus: "100€ de Paris Gratuits",
    secondaryBonus: "Poker n°1 en France",
    extraBonus: "Freerolls quotidiens",
    claimedCodes: 1823,
    url: "https://winamax.fr",
    score: 9.4,
    minDeposit: "10€",
    paymentMethods: ["Visa", "Mastercard", "PayPal", "Virement", "Neosurf"],
    authorized: "ARJEL",
    termsDetails: "Leader français du poker et paris sportifs. Interface 100% française.",
    gallery: []
  }
];

export default mockCasinos;